import { ISanityImage } from '@rbi-ctg/menu';
import { IOfferCarouselFragment } from 'generated/sanity-graphql';

export interface IOfferCarouselSectionProps {
  title: IOfferCarouselFragment['offerCarouselTitle'];
  offers: IOfferCarouselFragment['offerCarouselList'];
}

export interface OfferItemProps {
  offerId: string | null | undefined;
  favoriteId: string | null | undefined;
  image: ISanityImage | null | undefined;
  imageAlt: string | null | undefined;
  offerName: string | null | undefined;
  description: string | null | undefined;
  fullWidth: boolean;
  onClick?: () => void;
}

export enum CarouselDirection {
  ShiftLeft = -1,
  ShiftRight = 1,
}
